/* ============================================================
   SANTJAKOV — drawer de prenda
   Abre la ficha como capa sobre la rejilla, sin salir de la página, igual que
   el sitio estático. La diferencia es de dónde sale el contenido: allí se
   pintaba desde el CATALOG del navegador; aquí se le pide a Shopify la misma
   ficha que usa la página de producto (`?view=drawer`), así que las dos no se
   pueden desfasar.
   ============================================================ */
(function(){
  const D=document;
  const capa=D.getElementById('drawer'), fondo=D.getElementById('drawerBg');
  if(!capa) return;

  window.abrirFicha=h=>abrir(h);   /* lo usa el buscador de la barra */
  const cache=new Map();   /* una prenda ya abierta no se vuelve a pedir */
  let abierto=false;

  function abrir(handle){
    if(!handle) return;
    const pinta=html=>{
      capa.innerHTML=html;
      capa.classList.add('open');
      fondo&&fondo.classList.add('open');
      D.body.classList.add('ficha-abierta');
      if(window.lenis) window.lenis.stop();
      abierto=true;
      /* la ficha recién inyectada trae sus propios selectores de color y talla */
      if(window.montarFicha) window.montarFicha(capa);
    };
    if(cache.has(handle)){ pinta(cache.get(handle)); return; }
    fetch('/products/'+handle+'?view=drawer',{headers:{'X-Requested-With':'fetch'}})
      .then(r=>r.ok?r.text():Promise.reject(r.status))
      .then(html=>{ cache.set(handle,html); pinta(html); })
      .catch(err=>{
        /* si falla, se navega a la ficha completa: peor experiencia, pero el
           cliente llega igual a la prenda en vez de quedarse con un clic muerto */
        console.warn('[santjakov] no se pudo abrir la ficha en capa:',err);
        location.href='/products/'+handle;
      });
  }

  function cerrar(){
    if(!abierto) return;
    capa.classList.remove('open');
    fondo&&fondo.classList.remove('open');
    D.body.classList.remove('ficha-abierta');
    if(window.lenis) window.lenis.start();
    abierto=false;
  }

  /* Por delegación y en FASE DE CAPTURA: hay que llegar antes que el
     interceptor de transiciones de página, que si no se lleva el clic y navega
     con la cortina. Es el mismo motivo por el que aquel va en captura. */
  D.addEventListener('click',ev=>{
    if(ev.button||ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.altKey) return;
    const t=ev.target;
    if(t.closest&&t.closest('.d-close')){ ev.preventDefault(); ev.stopPropagation(); cerrar(); return; }
    /* LAS TARJETAS YA NO ABREN LA CAPA (12 oct 2026). Este oyente y el de las
       transiciones de página (`theme.js`) se registran los dos en captura, y
       `theme.js` va primero: el clic hacía las DOS cosas —pedía la ficha en
       capa y además navegaba a la página de la prenda—, así que la ficha
       aparecía un instante y enseguida cargaba la página entera. Se veía como
       una doble carga. Manda la página de producto, que es lo que Marcelo
       quiere al dar clic en una prenda; la capa queda solo para el buscador
       (`window.abrirFicha`). */
    return;
    const tarjeta=t.closest&&t.closest('.prod, .pc');
    if(!tarjeta) return;
    const href=tarjeta.getAttribute('href')||'';
    const m=href.match(/\/products\/([^/?#]+)/);
    if(!m) return;
    ev.preventDefault(); ev.stopPropagation();
    abrir(m[1]);
  },true);

  fondo&&fondo.addEventListener('click',cerrar);
  addEventListener('keydown',e=>{ if(e.key==='Escape') cerrar(); });
})();
